export default __webpack_public_path__ + "static/media/billboards_placeholder.c224be1a.svg";